import { Box, Button, Typography } from '@global-engineering-shared/gweb-material-ui';

import useStyles from 'components/Table/components/TableFooter/TableFooter.styles';
import { ITableFooter } from 'components/Table/types/Table';

const TableFooter = ({
  currentItems,
  totalItems,
  label,
  canLoadMore,
  handleLoadMore,
}: ITableFooter) => {
  const classes = useStyles();

  return (
    <Box className={classes.tableFooter}>
      {canLoadMore && (
        <Button variant="outlined" onClick={handleLoadMore} className={classes.loadMoreButton}>
          Load more
        </Button>
      )}
      <Typography variant="caption" className={classes.totalItems}>
        Showing {currentItems} of {totalItems}
      </Typography>
    </Box>
  );
};

export default TableFooter;
